<template>

  <div class="footer"  >

    <div class="footer">

    <div class="box1">

      <div class="box">

        <div class="fleft">

          <div class="logo"><a href="/"><img :src="require('@/assets/newImage/logo-foot.png')" alt=""></a></div>

          <div class="txt">{{$t('message.address')}}</div>

        </div>

        <div  class="fright">
<!-- 
          <div    class="tbox">
            <div  class="t1">{{ item.typename }}
              <div style="margin-bottom: 30px;"></div>
              <div  v-for="childItem in item.children" :key="childItem.id"  @click="handleDropdownItemClick(childItem)"><a >{{ childItem.typename }}</a></div>
            </div>

          </div> -->
        <div class="tbox">
        <div class="t1"> {{$t('message.quickNav')}}</div>
          <router-link to="/about/">{{$t('message.about')}}</router-link>
          <router-link to="/news/">{{$t('message.technologyIntro')}}</router-link>
          <router-link to="/price/">{{$t('message.price')}}</router-link>
         </div> 

         <div class="tbox">
        <div class="t1"> {{$t('message.support')}}</div>
          <router-link to="/privacy/">{{$t('message.privacy')}}</router-link>
          <router-link to="/FAQ/">{{$t('message.faq')}}</router-link>
          <router-link to="/contact/">{{$t('message.contact')}}</router-link>
         </div>
        </div>

      </div>

    </div>

    <div class="box2">

      <div class="box">

        <div class="copyright" style="border: none">©2015-2021 {{$t('message.copyright')}} <a href="https://beian.miit.gov.cn"><a href="http://beian.miit.gov.cn/" rel="nofollow" target="_blank">{{$t('message.icp')}}</a></a></div>

        <div class="flink">


          <a href="/">{{$t('message.legal')}}</a>


          <a @click="goMap" >{{$t('message.siteMap')}}</a>

        </div>

      </div>

    </div>

  </div>


  </div>

</template>

<script>
export default {
  name: "footer",


  data() {
    return {
      data1:[]

    };
  },
  mounted() {

    this.fetchData()
  },
  methods: {
goMap(){
  this.$router.push({path:"map"})


},
    handleDropdownItemClick(childItem) {
      // 处理 <el-dropdown-item> 被点击的逻辑
      // console.log('Dropdown item clicked:', childItem);
      // 添加其他逻辑...
      if(childItem.typename==="隐私条款"){
        this.$router.push({path:"privacy"})
      }
      if(childItem.typename==="价格"){
        this.$router.push({path:"price"})
      }
      if(childItem.newCategory===1){
        this.id=childItem.id;
        sessionStorage.setItem('a', this.id);
        this.$router.push({
          name: 'templete2', // 使用路由的 name 属性
          params: { a: this.id }
        });
      }
    },
    fetchData() {
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http.get('yasubit/website/list', { headers })
          .then(response => {
            // 请求成功时更新数据
            // console.log(1111111111);
            this.data = response.data.data.position1;
            this.data1 = response.data.data.position3;
            // console.log(this.data)
            // console.log("底部")
            // console.log(this.data1)
          })
          .catch(error => {
            // 请求失败时处理错误
            console.error('Error fetching data:', error);
          });
      // // 发送 GET 请求
      // this.$http.get('/system/user/deptTree')
      //     .then(response => {
      //       // 请求成功时更新数据
      //       console.log(1111111111)
      //       // this.data = response.data;
      //     })
      //     .catch(error => {
      //       // 请求失败时处理错误
      //       console.error('Error fetching data:', error);
      //     });
    },



    foot1(){

      this.$router.push({
        name: 'about'

      }).then(() => {
        window.scrollTo(0, 0);
      });

    },
    foot2(){

      this.$router.push({
        name: 'technology'

      }).then(() => {
        window.scrollTo(0, 0);
      });

    },
    foot3(){

      this.$router.push({
        name: 'privacy'

      }).then(() => {
        window.scrollTo(0, 0);
      });

    },
    foot4(){

      this.$router.push({
        name: 'FAQ'

      }).then(() => {
        window.scrollTo(0, 0);
      });

    },
    foot5(){

      this.$router.push({
        name: 'contact'

      }).then(() => {
        window.scrollTo(0, 0);
      });

    },
    foot6(){

      this.$router.push({
        name: 'FAQ'

      }).then(() => {
        window.scrollTo(0, 0);
      });

    },
  }
}




</script>

<style scoped lang="scss">

</style>